<template lang="pug">
form#item-bulk
    fieldset(:disabled="loading")
        h6.m-b-md Options

        .form-group
            label.md-check.m-b-sm
                input(
                    type="checkbox"
                    v-model="update_category"
                )
                i.indigo
                | Category

            multiselect(
                placeholder="Select category"
                name="category"
                label="name"
                track-by="id"
                v-model="category"
                :disabled="!update_category"
                :options="categories"
            )

        .form-group
            label.md-check.m-b-sm
                input(
                    type="checkbox"
                    v-model="update_tag"
                )
                i.indigo
                | Tags

            multiselect(
                placeholder="Select tags"
                name="tag"
                label="name"
                track-by="id"
                v-model="tags"
                :disabled="!update_tag"
                :multiple="true"
                :max="tagLimit"
                :options="tagList"
            )

        .form-group
            label.md-check.m-b-sm
                input(
                    type="checkbox"
                    v-model="update_modifier"
                )
                i.indigo
                | Modifiers

            multiselect(
                placeholder="Select modifiers"
                name="modifiers"
                label="name"
                track-by="id"
                v-model="modifiers"
                :disabled="!update_modifier"
                :multiple="true"
                :options="modifierSetList"
            )

        .form-group
            label.md-check.m-b-sm
                input(
                    type="checkbox"
                    v-model="update_tax"
                )
                i.indigo
                | Taxes

            multiselect(
                placeholder="Select taxes"
                name="taxes"
                label="name"
                track-by="id"
                v-model="taxes"
                :disabled="!update_tax"
                :multiple="true"
                :options="taxList"
            )

        .form-group
            label.md-check.m-b-sm
                input(
                    type="checkbox"
                    v-model="update_status"
                )
                i.indigo
                | Status

            p
                label.md-switch
                    input(
                        v-model="status"
                        type="checkbox"
                        :disabled="!update_status"
                    )
                    i.indigo
                    | Hide product

        .form-group
            label.md-check.m-b-sm
                input(
                    type="checkbox"
                    v-model="update_override_media"
                )
                i.indigo
                | {{ trans('product.allow_media_override') }}

            p
                label.md-switch
                    input(
                        v-model="allow_media_override"
                        type="checkbox"
                        :disabled="!update_override_media"
                    )
                    i.indigo
                    | {{ trans('product.allow_media_override') }}
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { Event } from '../../../event-bus';
import Unleash from '@js/plugins/unleash';

export default {
    data() {
        return {
            allow_media_override: null,
            category: null,
            modifiers: [],
            status: null,
            tags: [],
            // PS-10978: one tag per product while the upgrade flag is on
            tagLimit: Unleash.hasFeature('sentinel_laravel_upgrade')
                ? 1
                : false,
            taxes: [],
            update_category: false,
            update_modifier: false,
            update_override_media: false,
            update_status: false,
            update_tag: false,
            update_tax: false,
        };
    },

    computed: {
        ...mapGetters('category', ['categories']),
        ...mapGetters('modifierSet', ['modifierSetList']),
        ...mapGetters('tag', ['tagList']),
        ...mapGetters('tax', ['taxList']),

        loading() {
            return this.onLoading('save-product');
        },

        updatePayload() {
            let payload = {
                ids: this.$store.getters['VUETABLE_ITEM_CHECKBOX/getSelected'],
            };

            if (this.update_category) {
                payload.category_id = this.category ? this.category.id : null;
            }

            if (this.update_modifier) {
                payload.modifier_sets = this.modifiers.map(r => r.id);
            }

            if (this.update_override_media) {
                payload.allow_media_override = this.status ? 0 : 1;
            }

            if (this.update_status) {
                payload.status = this.status ? 0 : 1;
            }

            if (this.update_tag) {
                payload.tags = this.tags.map(r => r.id);
            }

            if (this.update_tax) {
                payload.taxes = this.taxes.map(r => r.id);
            }

            return payload;
        },
    },

    methods: {
        ...mapActions('product', ['bulkUpdateProducts']),

        resetForm() {
            this.category = null;
            this.modifiers = [];
            this.status = false;
            this.tags = [];
            this.taxes = [];
            this.update_category = false;
            this.update_modifier = false;
            this.update_status = false;
            this.update_tag = false;
            this.update_tax = false;
        },

        submit() {
            this.bulkUpdateProducts(this.updatePayload)
                .then(u => {
                    Event.$emit('bulk-product-updated');
                    this.resetForm();
                })
                .catch(e => {
                    this.showApiError(e);
                });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/item/item-bulk.vue